(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-upsell"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function (event) {
    var select = event.target.closest('.product-upsell__variant-select');
    if (!select) return;
    var root = select.closest('.product-upsell');
    var option = select.options[select.selectedIndex];
    var input = root.querySelector('input[name="id"]');
    if (input) input.value = select.value;
    var price = root.querySelector('.product-upsell__price--current');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    var image = root.querySelector('.product-upsell__image img');
    if (image && option.dataset.image) {
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
